export default __webpack_public_path__ + "static/media/icon-select.6ee0ef8d.svg";